import React from "react";
import { RecIcon } from "../materials/MaterialRecordParts";

/**
 * Compact Project Health for Project Detail on phones. Presents the SAME task
 * health the Dashboard and the Project cards use (`summarizeProjectTasks`):
 * completion, overdue / due-today / upcoming counts, plus the real target date.
 * Tapping opens the project's existing Tasks screen when one is available.
 */
export function ProjectHealthStrip({ health, targetLabel = "", onOpenTasks }) {
  if (!health) return null;
  const { total, completed, percent, overdue, today, upcoming } = health;
  const body = (
    <>
      <span className="pj-health__head">
        <span className="pj-health__title">Project Health</span>
        {targetLabel ? <span className="pj-health__target">Target {targetLabel}</span> : null}
      </span>
      {total > 0 ? (
        <>
          <span className="pj-health__progress">
            <span className="pj-health__bar" aria-hidden="true">
              <span style={{ width: `${percent}%` }} />
            </span>
            <b>{percent}%</b>
            <span className="pj-health__count">
              {completed} of {total} tasks
            </span>
          </span>
          <span className="pj-health__chips">
            {overdue > 0 ? <span className="pj-tchip pj-tchip--red">{overdue} overdue</span> : <span className="pj-tchip pj-tchip--green">On Track</span>}
            {today > 0 ? <span className="pj-tchip pj-tchip--gold">{today} today</span> : null}
            {upcoming > 0 ? <span className="pj-tchip pj-tchip--blue">{upcoming} upcoming</span> : null}
          </span>
        </>
      ) : (
        <span className="pj-health__empty">No tasks yet — progress appears once tasks are added.</span>
      )}
    </>
  );
  return onOpenTasks ? (
    <button type="button" className="pj-health pj-health--btn" onClick={onOpenTasks} aria-label="Project health — open tasks" data-testid="project-health">
      {body}
      <RecIcon name="chevron" className="pj-health__chev" />
    </button>
  ) : (
    <div className="pj-health" data-testid="project-health">
      {body}
    </div>
  );
}
